var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auto-done-enrolls--content"},[_c('div',{staticClass:"input-block"},[_c('div',{staticClass:"btn btn-sm btn-outline-info",on:{"dblclick":_vm.doneSubmit}},[_vm._v("Завершить старые записи")]),_c('div',{staticClass:"hint"},[_vm._v("Двойной клик по кнопке")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }